import { render, staticRenderFns } from "./distributorProduct.vue?vue&type=template&id=42170934&scoped=true"
import script from "./distributorProduct.vue?vue&type=script&lang=js"
export * from "./distributorProduct.vue?vue&type=script&lang=js"
import style0 from "./distributorProduct.vue?vue&type=style&index=0&id=42170934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42170934",
  null
  
)

export default component.exports